import { render, staticRenderFns } from "./ChangeBzjDlg.vue?vue&type=template&id=6b615248&scoped=true"
import script from "./ChangeBzjDlg.vue?vue&type=script&lang=js"
export * from "./ChangeBzjDlg.vue?vue&type=script&lang=js"
import style0 from "./ChangeBzjDlg.vue?vue&type=style&index=0&id=6b615248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b615248",
  null
  
)

export default component.exports